<div 
	id="search-query" 
	class="container header__container clearfix search-query" 
	*ngIf="currentQuery">

	<div class="search-query__text">
		{{"SEARCH.RESULT" | translate }}
	</div>

	<div class="search-query__query">
		{{currentQuery}}
		<div class="icon icon--close-gray" (click)="clearSearch()"></div>
	</div>

</div>
